export const ITEM_HEIGHT = 24;
export const RECALC_DELAY = 50;
export const COUNT_TAGS_ROW_GAP = 8;
export const COUNT_TAGS_MORE_WIDTH = 70;
